import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { getRandomExcelenteAvatar } from "../../utils/excelenteAvatar";
import ScenarioBar from "../../components/ScenarioBar";
import Scenario2NextCta from "./Scenario2NextCta";
import "../StartGame.css";
import "./Scenario2.css";

function Scenario2Fin() {
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);
	const excelenteAvatarUrl = useMemo(() => getRandomExcelenteAvatar(), []);

	return (
		<div className="start-game-page start-game-page--welcome sc2-context-page sc2-fin-page">
			<div className="start-game-inner start-game-inner--prep5">
				<span className="start-game-badge sg5-badge">
					<span className="start-game-badge-dot" aria-hidden />
					Escenario 1 · Diagnóstico
				</span>

				<div className="sg5-scroll">
					<header className="sg5-hero">
						<h1 className="sg5-title sc2-fin-phase-title">
							Has avanzado a la <span className="sg5-title-accent">siguiente fase</span>
						</h1>
					</header>

					<div className="sc2-fin-visual">
						<div className="quiz-result-avatar-row quiz-result-avatar-row--tight sc2-fin-excelente-row">
							<span className="quiz-result-badge quiz-result-badge--correct quiz-result-badge--t-orange">
								Excelente
							</span>
							<div className="quiz-result-avatar-shell fin-excelente-shell sc2-fin-excelente-shell">
								<div className="quiz-result-avatar-inner">
									<img src={excelenteAvatarUrl} alt="" className="quiz-result-avatar-img" />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="sg5-actions">
					<Scenario2NextCta
						navigateTo={ROUTES.TRANSITION_SCENARIOS}
						activeScenario={3}
						label="Avanzar a la siguiente fase"
					/>
				</div>
			</div>

			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default Scenario2Fin;
